/**
 *
 * Accordions
 *
 */

const openTriggerCollection = document.querySelectorAll('.js-accordion-open');
const closeTriggerCollection = document.querySelectorAll('.js-accordion-close');
const nestedContentCollection = document.querySelectorAll('.accordion__nested-content');
const itemCollection = document.querySelectorAll('.accordion__item');

for (var i = 0; i < closeTriggerCollection.length; i ++) {
    closeTriggerCollection[i].classList.add('hide');
}

for (var i = 0; i < nestedContentCollection.length; i ++) {
    nestedContentCollection[i].classList.add('hide');
}

document.addEventListener('click', function(event) {

    let clickedElement = event.target;

    if (clickedElement.classList.contains('js-accordion-open')) {
        event.preventDefault();
        clickedElement.classList.add('hide');
        clickedElement.previousElementSibling.classList.remove('hide');
        clickedElement.previousElementSibling.previousElementSibling.classList.remove('hide');
        clickedElement.parentNode.classList.add('open');

    } else if (clickedElement.classList.contains('js-accordion-close')) {
        event.preventDefault();
        clickedElement.classList.add('hide');
        clickedElement.nextElementSibling.classList.remove('hide');
        clickedElement.previousElementSibling.classList.add('hide');
        clickedElement.parentNode.classList.remove('open');
    } else {
        return;
    }
});


// For product page, make accordion open by default
$(document).ready(function(){
  
    if ($('.template-product').length) {
      
        if ( $('.accordion').length ) {
            
            $('.accordion').find('.accordion__list').find('li:first-child').find('.js-accordion-open').trigger('click');

        }

    }
  
  });